// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InstagramOutlinedSvg from "@fishx/icons-svg/es/asn/InstagramOutlined";
import FishxIcon from '../components/FishxIcon';

var InstagramOutlined = function InstagramOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: InstagramOutlinedSvg
  }));
};

InstagramOutlined.displayName = 'InstagramOutlined';
export default React.forwardRef(InstagramOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/InstagramOutlined.js
// module id = 2981
// module chunks = 0